<template>
  <div id="creator_agency_history" :class="isFull === 1 ? 'bdm_center0 top_information1' : ' bdm_center0'">
    <van-nav-bar :title="$t('title.history_list')" placeholder fixed @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="24">
        <van-col span="12">
          <van-tabs v-model="active" line-width="20px" title-inactive-color="#999999">
            <van-tab :title="$t('column.creator')"></van-tab>
            <van-tab :title="$t('column.gift_income')"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="12">
          <van-cell @click="dateShow = true" is-link arrow-direction="down">
            <template #default>
              <img src="../assets/img/creator/creator_agency_tab_time.png" class="creator_agency_tab_time"/>
              <span class="custom-title">{{ date }}</span>
            </template>
          </van-cell>
        </van-col>
      </van-col>
      <!--   列表   -->
      <van-col span="24">
        <van-col span="24" v-if="active === 1">
          <!--    gift      -->
          <van-col span="22" offset="1" class="creator_agency_history_list" v-for="(t,j) in list" :key="j">
            <van-col span="22" offset="1">
              <van-col span="22" class="creator_agency_history_list_title">{{ t.date }}</van-col>
              <van-col span="8">
                <van-col span="24" class="creator_agency_history_list_name">{{ $t('column.gift_income') }}</van-col>
                <van-col span="24" class="creator_agency_history_list_img"><img src="../assets/img/coin9.png"/> {{ t.gift_income }} </van-col>
              </van-col>
              <van-col span="8">
                <van-col span="24" class="creator_agency_history_list_name">{{ $t('column.commission_rate') }}</van-col>
                <van-col span="24" class="creator_agency_history_list_ratio">{{ t.gift_rate }}%</van-col>
              </van-col>
              <van-col span="8">
                <van-col span="24" class="creator_agency_history_list_name">{{ $t('column.gift_commission') }}</van-col>
                <van-col span="24" class="creator_agency_history_list_img"><img src="../assets/img/coin9.png"/> {{ t.gift_bonus_income }} </van-col>
              </van-col>
            </van-col>
          </van-col>
        </van-col>
        <van-col span="24" v-else>
        <!--    creator      -->
          <van-col span="22" offset="1" class="creator_agency_history_list" v-for="(item,i) in list" :key="i">
            <van-col span="22" offset="1">
              <van-col span="22" class="creator_agency_history_list_title">{{ item.date }}</van-col>
              <van-col span="12" >
                <van-col span="24" class="creator_agency_history_list_name">{{ $t('column.commission_rate') }}</van-col>
                <van-col span="24" class="creator_agency_history_list_ratio">{{ item.rate }}%</van-col>
              </van-col>
              <van-col span="12">
                <van-col span="24" class="creator_agency_history_list_name">{{ $t('column.your_income') }}</van-col>
                <van-col span="24" class="creator_agency_history_list_img"><img src="../assets/img/coin9.png"/> {{ item.bonus_income }}</van-col>
              </van-col>
            </van-col>
          </van-col>
        </van-col>
      </van-col>
    </van-row>

    <van-popup v-model="dateShow" position="bottom" :style="{ height: '40%',width: '100%' }">
      <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          :min-date="minDate"
          :max-date="maxDate"
          :title="$t('column.select_date')"
          :confirm-button-text="$t('btn.confirm')"
          :cancel-button-text="$t('btn.cancel')"
          @confirm="onConfirmDate"
          @cancel="dateShow = false"
      />
    </van-popup>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import uploadImage from '@/components/upload_image.vue';
import {Dialog, DatetimePicker} from "vant";

export default {
  components: { DatetimePicker },
  data() {
    return {
      list: [],
      active: 0,
      dateShow: false,
      date: '',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(new Date().setHours(23,59,59,999)),
      currentDate: new Date(),
      isFull: 0,
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    let year = this.currentDate.getFullYear();
    let month = this.currentDate.getMonth() + 1;
    this.date = year + '-' + month
    this.getList()
  },
  methods: {
    onConfirmDate(time) {
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      this.date = year + '-' + month
      this.getList()
      this.dateShow = false
    },
    getList(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_center_history",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.list = res.data.data.list
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1);
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/creator_agency_history.vue